// The Supabase address and publishable key come from the environment, never the repo.
// Locally: .env.local (git-ignored). On Cloudflare Pages and in GitHub Actions: their settings.
// The publishable key is safe in the browser; the database's row rules protect the data.

export interface SupabaseConfig {
  url: string;
  publishableKey: string;
}

export function readConfig(env: Record<string, string | undefined>): SupabaseConfig | null {
  const url = env.VITE_SUPABASE_URL?.trim();
  const publishableKey = env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim();
  if (!url || !publishableKey) return null;
  if (!/^https:\/\/[a-z0-9-]+\.supabase\.co\/?$/.test(url)) return null;
  return { url: url.replace(/\/$/, ''), publishableKey };
}

/** Which Supabase project the site is talking to, shown in small print. */
export function projectLabel(config: SupabaseConfig | null): string {
  if (!config) return 'not connected';
  const ref = new URL(config.url).hostname.split('.')[0];
  if (ref === 'culrrqugvioagswtkebq') return 'test';
  if (ref === 'wpgyfkfqqlyawikiaxmz') return 'live';
  return 'unknown project';
}
